__turbopack_context__.v({
  "alignCenter": "SectionHeader-module-scss-module__bslMSa__alignCenter",
  "alignLeft": "SectionHeader-module-scss-module__bslMSa__alignLeft",
  "alignRight": "SectionHeader-module-scss-module__bslMSa__alignRight",
  "header": "SectionHeader-module-scss-module__bslMSa__header",
  "noGutters": "SectionHeader-module-scss-module__bslMSa__noGutters",
  "withGutters": "SectionHeader-module-scss-module__bslMSa__withGutters",
});
